import React from 'react';
import { ReportOutputType, ReportType } from '../../graphql/schema/p4types';
import { useFormContext } from 'react-hook-form';
import Dropdown from '../connectedForm/Dropdown';
import { IDocumentValues, useDocumentCarouselStyles } from './documentCarouselUtil';
import Fieldset from '../connectedForm/Fieldset';
import { Switch } from '@fluentui/react-components';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import { findDocumentSource, sourceTypes } from './DocumentSource';
import { SystemPrinter } from '../../graphql/entities';
import QueryDropdown from '../connectedForm/QueryDropdown';

const DocumentCarouselOutput = ({
  reportType,
  singleRecipient,
  outputTypes,
}: {
  reportType?: ReportType;
  singleRecipient: boolean;
  outputTypes?: Array<IEnumMeta>;
}) => {
  const { watch, setValue } = useFormContext<IDocumentValues>();

  const outputType = watch('outputType');
  const overrideOutput = watch('overrideOutput');

  const displayOverride = !singleRecipient;

  const documentSource = reportType ? findDocumentSource(reportType) : sourceTypes.customer;

  const styles = useDocumentCarouselStyles();

  return (
    <div className={styles.row}>
      {displayOverride ? (
        <Fieldset cols={1 / 2} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Switch
            data-testid="document-carousel-override-output"
            className={styles.switch}
            checked={overrideOutput}
            label={
              overrideOutput
                ? 'Select output for this print operation'
                : `${documentSource?.label ?? 'Customer'} default output will be used`
            }
            onChange={(ev, data) => {
              setValue('overrideOutput', data.checked ?? false, { shouldTouch: true, shouldDirty: true });
            }}
          />
        </Fieldset>
      ) : null}
      {overrideOutput ? (
        <Fieldset cols={displayOverride ? 1 / 2 : 1} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Dropdown
            options={outputTypes ?? fieldMetaData.DocumentOutputType.enumValues}
            valueKey="value"
            labelKey="label"
            onChange={(newOutputType) => {
              setValue('outputType', newOutputType, {
                shouldTouch: true,
                shouldDirty: true,
              });
            }}
            valueOnly={true}
            label="Output"
            includeLabel={!displayOverride}
            value={outputType}
            clearable={false}
            data-testid={'document-carousel-output'}
          />
          {outputType === ReportOutputType.SystemPrinter ? (
            <QueryDropdown
              {...SystemPrinter.dropdown}
              label="System Printer"
              onChange={(value: number) => {
                setValue('printerId', value, {
                  shouldTouch: true,
                  shouldDirty: true,
                });
              }}
              value={watch('printerId')}
              valueKey="id"
              labelKey="printerName"
              valueOnly
              data-testid={'document-carousel-system-printer'}
            />
          ) : null}
        </Fieldset>
      ) : null}
    </div>
  );
};

export default DocumentCarouselOutput;
